import { post } from "../../shared/lib/api"

const logIFTTTNextAction = window.logIFTTTNextAction || ((eventName, params = {}) => {})

export default logIFTTTNextAction
